import { MedicalField, MedicalFieldQuery } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { AutosuggestItemRenderer, AutosuggestLabelExtractor, AutosuggestSearchCreator } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

export const medicalFieldItemRenderer: AutosuggestItemRenderer<MedicalField> = (item) => (
   <>
      {item.code} {item.name}
   </>
);
export const medicalFieldLabelExtractor: AutosuggestLabelExtractor<MedicalField> = (item) =>
   `${item.code} ${item.name}`;
export const medicalFieldKeyPropertyExtractor = (item: MedicalField): string => item.code;

export const medicalFieldSearchCreator: AutosuggestSearchCreator<MedicalField> = (searchText) => {
   return async () =>
      performCqrsQuerySearch<MedicalField>(() => {
         const query = new MedicalFieldQuery();
         if (searchText) {
            query.nameOrCode = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      });
};
